<ng-container *ngIf="options">
    <div class="modal-header" *ngIf="options.title">
        <h3>{{options.title}}</h3>
        <aurora-icon-button *ngIf="options.dismissButton" class="close" icon="times" variant="ghost" size="large" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        </aurora-icon-button>
    </div>
    <div class="modal-body" *ngIf="options.message" [style]="options.messageStyle">
        {{options.message}}
    </div>
    <div *ngIf="options.buttons" class="modal-footer">
        <aurora-button
                *ngIf="options.buttons.leftButton"
                [attr.variant]="options.buttons.leftButton.class || 'primary'"
                (click)="performAction(options.buttons.leftButton)">
            {{options.buttons.leftButton.label}}
        </aurora-button>
        <aurora-button
                *ngIf="options.buttons.centerButton"
                class="ms-1"
                [attr.variant]="options.buttons.centerButton.class || 'secondary'"
                (click)="performAction(options.buttons.centerButton)">
            {{options.buttons.centerButton.label}}
        </aurora-button>
        <aurora-button
                *ngIf="options.buttons.rightButton"
                class="ms-1"
                [attr.variant]="options.buttons.rightButton.class || 'ghost'"
                (click)="performAction(options.buttons.rightButton)">
            {{options.buttons.rightButton.label}}
        </aurora-button>
    </div>
</ng-container>
<div *ngIf="!options" class="modal-body">No DialogOptionsSet</div>